// Local URL => 'http://172.21.4.102/medicallink/api'
// Demo URL =>  'https://medicallink-online.fr/api'
// Live URL =>  'https://hypokrate.com/api'

// const isDemo = true ? 'https://medicallink-france.fr' : 'https://medicallink.fr'

const URL = {
    endpoint: 'https://medicallink-online.fr/api',
    login: 'https://medicallink-online.fr/login/5?h=0'
};

export const MapURL = 'https://maps.googleapis.com/maps/api'

export default URL;
